import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { selectToken } from '@caudena/web-platform/dist/tokens/utils/selectToken'
import { createTokenKey } from '@caudena/web-platform/dist/tokens/utils/createTokenKey'
import { Link as RouterLink } from 'react-router-dom'
import { shouldForwardProp } from '../../emotion'
export const Container = styled.div`
  position: relative;
`

interface LinkProps {
  $isOpen: boolean
  $variant: 'wide' | 'short'
}

export const Link = styled(RouterLink, { shouldForwardProp })<LinkProps>`
  position: absolute;
  top: 0;
  display: flex;
  padding: 4px;
  border-radius: 4px;
  gap: 2px;
  transition: opacity 0.2s;
  white-space: nowrap;

  ${({ $variant, $isOpen }) =>
    $variant === 'wide'
      ? css`
          right: 16px;
          left: 16px;
          flex-direction: row;
          opacity: ${$isOpen ? 1 : 0};
          visibility: ${$isOpen ? 'visible' : 'hidden'};
        `
      : css`
          right: 6px;
          left: 6px;
          flex-direction: column;
          align-items: center;
          opacity: ${$isOpen ? 0 : 1};
          visibility: ${$isOpen ? 'hidden' : 'visible'};
        `}

  &:hover {
    background-color: ${({ theme }) =>
      selectToken(theme, createTokenKey(['grey600']))};
    color: ${({ theme }) => selectToken(theme, createTokenKey(['white']))};
  }
`
